import { ProFormField } from '@ant-design/pro-form';
import { useLocalStorageState } from 'ahooks';
import { AutoComplete, FormInstance } from 'antd';
import React, { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { InputFormType } from '@/presentation/components/form';

interface IProps {
  searchCount: number;
  entry: InputFormType;
  hidden?: boolean;
  form?: FormInstance,
  onChange?: (value: Record<string, any>, fields: Record<string, any>) => void;
}
const FORM_INPUT_OPTION = 'form-input-option';

export const InputForm: FC<IProps> = (props) => {
  const { searchCount, entry, hidden, form  } = props;
  const { name, label, rules, transform, convertValue, placeholder, defaultOptions } = entry;
  const { t } = useTranslation();
  const [inputOption, setInputOption] = useLocalStorageState<Record<string, any[]>>(
    FORM_INPUT_OPTION,
    { defaultValue: {} },
  );
  const [search, setSearch] = useState('');
  const [open, setOpen] = useState(false);
  useEffect(() => {
    if (searchCount > 0) {
      updateOption();
    }
  }, [searchCount]);
  const onSearch = (value: string) => {
    if (entry.enableAutoSearch) {
      props?.onChange?.(form?.getFieldValue(entry.name), form?.getFieldsValue());
    }
    setSearch(value);
    setOpen(true);
  };
  const updateOption = () => {
    if (!search) {
      return;
    }
    const detail = [...new Set([search, ...(inputOption?.[name]?.filter?.(str => str && typeof(str) === 'string') || [])])];
    if (detail.length > 20) {
      detail.splice(0 - (detail.length - 20), detail.length - 20);
    }
    setInputOption(data => ({ ...data, [name]: detail }));
  };
  const options = (inputOption?.[name]?.filter?.(str => !!(str && typeof (str) === 'string'))?.map?.(str => ({
    value: str,
    label: str,
  })) || []).concat(defaultOptions || []);
  const defaultFilterOption = (inputValue: string, option: any) => option?.
    label?.toLowerCase().indexOf(inputValue.toLowerCase()) >= 0;

  return <ProFormField
    placeholder={placeholder}
    hidden={hidden}
    rules={rules}
    label={label}
    name={name}
    transform={transform}
    convertValue={convertValue}>
    <AutoComplete
      filterOption={defaultFilterOption}
      open={open}
      onSelect={() => setOpen(false)}
      onBlur={() => setOpen(false)}
      onFocus={() => setOpen(true)}
      defaultOpen={false}
      options={options?.length ? options : undefined}
      onSearch={onSearch}
      placeholder={placeholder || t('请输入')}/>
  </ProFormField>;
};
